"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const Nutrition = __importStar(require("../../../../../../../nutrition"));
const unit_1 = require("../../../../../../../unit");
const mix_ratio_1 = require("../../enhancement/mix-ratio");
const style_1 = require("../../enhancement/style");
const common_1 = require("../common");
exports.default = {
    ...common_1.SENSIENT_1500_ML_BIB_RANGE,
    _tag: 'LiquidEnhancement',
    id: 'watermelon',
    name: 'Watermelon',
    description: 'The sweet and juicy burst of flavor that this hydrating fruit provides ' +
        'is reminiscent of a summer day leaving a pleasant and slightly sweet finish ' +
        'that is true to the fruit.',
    flavored: true,
    flavor: 'Watermelon',
    nominalMixRatio: common_1.SENSIENT_NOMINAL_MIX_RATIO,
    mixRatioScalars: mix_ratio_1.MixRatioScalars.make([
        0.8, // 125:1
        1, // 100:1
        2, // 50:1
    ]),
    tags: [],
    nutritionalInfo: Nutrition.make({
        energy: unit_1.Energy.Kilocalorie.make({ amount: 83.6 }),
        macro: {
            carbohydrate: {
                total: unit_1.Mass.Gram.make({ amount: 15.9 }),
            },
        },
        micro: {
            sodium: unit_1.Mass.Milligram.make({ amount: 8 }),
            potassium: unit_1.Mass.Milligram.make({ amount: 13.3 }),
            vitaminC: unit_1.Mass.Milligram.make({ amount: 0.01 }),
            calcium: unit_1.Mass.Milligram.make({ amount: 0.03 }),
        },
    }),
    ingredients: [
        'Water',
        'Propylene Glycol',
        'Ethyl Alcohol',
        'Natural Flavor',
        'Citric Acid',
        'Sodium Benzoate',
        'Potassium Sorbate',
    ],
    supplier: 'Sensient Flavors LLC',
    formulationDate: '2024-11-18T00:00:00.000Z',
    style: {
        colors: (0, style_1.makePelicanStyleColors)({
            light: '#D4EFBB',
            dark: '#5C9F24',
            text: '#5E9F25',
        }),
        coverImage: 'https://cgwiotstcfstst.blob.core.windows.net/public/one-tool/consumableSubset/watermelon.png',
    },
};
//# sourceMappingURL=watermelon.js.map